import { render, staticRenderFns } from "./StockMovementMovementTypeBadge.vue?vue&type=template&id=e6b486e0"
import script from "./StockMovementMovementTypeBadge.vue?vue&type=script&lang=js"
export * from "./StockMovementMovementTypeBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports